
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

@Options ({
    data () {
        return {
            isOpening: false,
            blessings: ['团团圆圆，平安喜乐！', '今夜的月亮，散着团圆的光！', '闹元宵，汤圆吃出幸福新一年！', '月圆心甜，幸幸福福新一年！', '元宵月，愿与你共赏团圆！', '甜蜜汤圆，是节日最好的礼物！', '闹花灯，吃汤圆，和和美美又一年！', '点一盏元宵灯；吃一碗甜汤圆！'],
            resultImg: ''
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'hbData'])
    },
    mounted () {
        this.resultImg = require(`@/assets/img/result_0${Math.floor(Math.random() * 5) + 1}.png`)
        this.$common.track('load', '进入抽奖页')
        this.$common.pageLoaded()
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_RESULTDATA']),
        open () {
            this.$common.track('click', '拆红包')
            // 祝福红包
            if (!this.hbData.amount) {
                this.goResult()
                return
            }
            this.getCash()
        },
        getCash () {
            if (this.isOpening) return
            this.isOpening = true
            this.$request('/lottery/cash', {
                aid: this.aid,
                pid: this.hbData.pid
            }, 'put').then((data: any) => {
                this.isOpening = false
                this.goResult()
            }).catch((res: any) => {
                if (res && res.errno == 1001 && res.errmsg == 'V2_ACCOUNT_SIMPLE_BAN') {
                    this.SET_DIALOGDATA({
                        text: '您的微信未实名认证，不能领取红包，请实名认证后领取',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else if (!res || !res.errno || (res.errno && res.errno != 1250 && res.errno != 1010)) {
                    this.$common.toast('加载失败，请重试！')
                }
                this.isOpening = false
            })
        },
        goResult () {
            const resultData = Object.assign(this.hbData, {
                resultImg: this.resultImg
            })
            sessionStorage.setItem('YUANXIAOJIEHONGBAOHBDATA', JSON.stringify(resultData))
            this.SET_RESULTDATA(JSON.parse(JSON.stringify(resultData)))
            this.$router.replace({
                path: '/result'
            })
        }
    }
})
export default class Complete extends Vue {}
